/* Adapted for BARBAS from KHI-X/P44HATZ/assets/site-background.js. */
(function () {
  document.querySelectorAll('.BarbasAccess__galaxy').forEach(function (canvas) {
  var root = canvas.closest('.Password__SmsSuccess, .PreviewSuccess, .BarbasAccess, .BarbasAccess__signupShell');
  var context = canvas.getContext('2d');
  if (!context || !root) return;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var stars = [];
  var width = 0;
  var height = 0;
  var touchX = 0;
  var touchY = 0;
  var driftX = 0;
  var driftY = 0;

  function resize() {
    width = canvas.clientWidth || window.innerWidth;
    height = canvas.clientHeight || window.innerHeight;
    var ratio = Math.min(window.devicePixelRatio || 1, 1.5);
    canvas.width = Math.round(width * ratio);
    canvas.height = Math.round(height * ratio);
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
    stars = [];
    var count = width < 650 ? 130 : 280;
    var radius = Math.hypot(width, height) * .6;
    for (var index = 0; index < count; index += 1) {
      stars.push({
        orbit: 20 + Math.random() * radius,
        angle: Math.random() * Math.PI * 2,
        speed: (.00004 + Math.random() * .00014) * (Math.random() < .5 ? -1 : 1),
        size: .45 + Math.random() * 1.15,
        opacity: .3 + Math.random() * .45,
        phase: Math.random() * Math.PI * 2
      });
    }
    draw(0);
  }

  function draw(time) {
    context.globalCompositeOperation = 'source-over';
    context.globalAlpha = 1;
    context.fillStyle = '#050505';
    context.fillRect(0, 0, width, height);
    context.fillStyle = '#ffffff';
    driftX += (touchX - driftX) * .06;
    driftY += (touchY - driftY) * .06;
    var centerX = width * .5;
    var centerY = height * .46;
    for (var index = 0; index < stars.length; index += 1) {
      var star = stars[index];
      var angle = star.angle + time * star.speed;
      var depth = .35 + star.orbit / (Math.hypot(width, height) * .6);
      var x = centerX + Math.cos(angle) * star.orbit + driftX * depth;
      var y = centerY + Math.sin(angle) * star.orbit * .65 + driftY * depth;
      var twinkle = .75 + .25 * Math.sin(time * .0015 + star.phase);
      context.globalAlpha = star.opacity * twinkle;
      context.beginPath();
      context.arc(x, y, star.size, 0, Math.PI * 2);
      context.fill();
    }
  }

  function animate(time) {
    window.requestAnimationFrame(animate);
    if (root.hidden || document.hidden || reducedMotion.matches) return;
    draw(time);
  }

  resize();
  root.addEventListener('pointermove', function (event) {
    if (event.pointerType !== 'touch' && !window.matchMedia('(pointer: coarse)').matches) return;
    touchX = (event.clientX / window.innerWidth - .5) * 42;
    touchY = (event.clientY / window.innerHeight - .5) * 42;
  }, { passive: true });
  window.addEventListener('resize', resize, { passive: true });
  if (window.ResizeObserver) new ResizeObserver(resize).observe(canvas);
  if (!reducedMotion.matches) window.requestAnimationFrame(animate);
  });
}());
